import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import api from '../lib/api';
import { loginSuccess, logout, setInitialized } from '../store/slices/authSlice';

/**
 * Hook to initialize authentication state by checking for an existing
 * session token with the backend API.
 * Should be called once at the app root level.
 */
export const useAuthInit = () => {
  const dispatch = useDispatch();
  const isInitializedRef = useRef(false);

  useEffect(() => {
    if (isInitializedRef.current) return;

    const initializeAuth = async () => {
      try {
        const token = localStorage.getItem('access_token');

        if (!token) {
          isInitializedRef.current = true;
          dispatch(setInitialized());
          return;
        }

        // Validate the token with the backend
        const data = await api.auth.me();

        if (!isInitializedRef.current) {
          isInitializedRef.current = true;

          if (data?.user) {
            dispatch(loginSuccess({
              user: data.user,
              token,
            }));
          } else {
            // Token invalid, clean up
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            dispatch(setInitialized());
          }
        }
      } catch (error) {
        console.error('Error initializing auth:', error);
        // Clear invalid tokens
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        if (!isInitializedRef.current) {
          isInitializedRef.current = true;
          dispatch(setInitialized());
        }
      }
    };

    initializeAuth();
  }, [dispatch]);
};

export default useAuthInit;
